import { createFileRoute, Link, useRouteContext } from "@tanstack/react-router";
import { Button } from "~/components/ui/button.tsx";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "~/components/ui/card.tsx";
import { accessDeniedHomeFor } from "~/lib/access-denied-target.ts";

export const Route = createFileRoute("/access-denied")({
  component: AccessDenied,
});

function AccessDenied() {
  const { hostname } = useRouteContext({ from: "__root__" });
  const home = accessDeniedHomeFor(hostname?.full ?? "");
  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-destructive/10">
            <svg
              className="size-6 text-destructive"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <CardTitle>Access denied</CardTitle>
          <CardDescription>
            You don't have permission to view this page.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center text-sm text-muted-foreground">
          <p>
            This area is restricted. If you believe you should have access, contact your administrator.
          </p>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button asChild>
            <Link to={home.to} data-testid="access-denied-home">
              {home.label}
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
